<template>
  <div>
    <div class="selectdiv mb-4">
      <div class="row">
        <div class="col-4">
          <div class="search-container">
            <tl-search @change="filterData($event)" :placeholder="'Search Employee Name'" />
          </div>
        </div>
        <div class="col-4">
          <!-- <span class="show-filter-block" @click="showFilter = !showFilter">
            <img class="search-icon-filter" src="@/assets/filter.png" alt="" />
            <span class="filter-text">Show Filter</span>
          </span> -->
        </div>
        <div class="col-4">
          <div class="float-right">
            <!-- <a class="anchor-underline-none download-block" href="#">
              <span class="mx-5">
                <img class="search-icon-filter" src="@/assets/logout-copy-3.svg" style="width: 30px;height: 34px;" alt /> <span class="filter-text">Download  </span>
              </span>  
            </a> -->
            <div class="grid-list-block">
            <img
              class="search-icon-filter"
              src="@/assets/emp-dir-list.svg"
              v-on:click="seen = false"
              alt
            /><span class="line"></span
            ><img
              class="search-icon-filter"
              src="@/assets/emp-dir-grid.svg"
              v-on:click="seen = true"
              alt
            />
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="grid-list" v-if="seen">
      <div
        class="employee mb-3"
        v-for="(item, index) in indirectReporteesList"
        :key="index"
      >
        <div class="employee-img">
          <div class="imgDetails">
            <img
              :src="item.photo"
              class="userImg"
              alt=""
              v-if="item.photo"
            />
            <img
              src="@/assets/user.svg"
              class="userImg"
              alt=""
              v-if="!item.photo"
            />
            <div>
              <p class="empId my-2">
                <strong>{{
                  item.code ? item.code : "-"
                }}</strong>
              </p>
              <div>
                <span class="empName"
                  >{{ item["name"] }}</span
                ><br />
                <div class="empDetails">
                  {{ item["designation"] ? item["designation"] : "-" }}
                  <!-- <br> {{empDept}}  -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="employee-details">
          <div class="details">
            <div>
              <img src="@/assets/phone-call.svg" alt="" />{{
                item["mobileNo"] ? item["mobileNo"] : "-"
              }}
            </div>
            <div>
              <img src="@/assets/mail.svg" alt="" />{{
                item["emailID"] ? item["emailID"] : "-"
              }}
            </div>
            <div>
              <img src="@/assets/placeholder.svg" alt="" />{{
                item["location"] ? item["location"] : "-"
              }}
            </div>
            <br />
            <div>
              Reports to <br />
              <strong>{{
                item["reportManagerName"] ? item["reportManagerName"] : "-"
              }}</strong>
            </div>
            <br />

            <div>
              <div>
                Expected DOJ <br />
                <strong>{{
                  item["doj"]
                    ? formatDate(item["doj"])
                    : "-"
                }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-list" v-else>
      <data-table
        :columns="employeeTableColumns"
        :tableData="indirectReporteesList"
        :checkbox="false"
        :withForm="false"
        :showinrow="false"
        :clickAllowed="true"
        id="empTable"
      >
        <template v-slot:rowcontent="slotprops">
         <img
            class="user-img"
            v-if="
              slotprops.value.column.key === 'photo' &&
              slotprops.value.record[slotprops.value.column.key]
            "
            :src="slotprops.value.record[slotprops.value.column.key]"
            alt=""
          />
          <img
            class="user-img"
            v-if="
              slotprops.value.column.key === 'photo' &&
              !slotprops.value.record[slotprops.value.column.key]
            "
            src="@/assets/user.svg"
            alt=""
          />
          <!-- <p v-if="slotprops.value.column.key === 'name'">
            {{ slotprops.value.record["name"] }}
          </p> -->
          <p v-if="slotprops.value.column.key !== 'photo'">
            {{ slotprops.value.record[slotprops.value.column.key] }}
          </p>
          <!-- <p
            v-if="
              slotprops.value.column.key === 'designation' ||
              slotprops.value.column.key === 'location'
            "
          >
            {{ slotprops.value.record[slotprops.value.column.key] }}
          </p> -->
        </template>
      </data-table>
    </div>

    <div v-if="showModal">
      <div class="modal custom-modal">
        <div class="modal-content modal-sm modal-border-radius">
          <div class="modal-emp-header">
            <img
              src="@/assets/close.png"
              class="close-img"
              v-on:click="showModal = false"
              alt=""
            />

            <div class="row">
              <div class="col-12 text-center">
                <img
                  src="@/assets/user.svg"
                  class="modal-user-img"
                  alt=""
                /><br />
                <span class="modal-emp-name">{{ modalRecord[0][0]["first_name"] }} {{ modalRecord[0][0]["last_name"] }}</span
                ><br />
                <span class="modal-emp-code"
                  >Employee Code: <strong> {{ modalRecord[0][0]["code"] }} </strong></span
                >
              </div>
            </div>
          </div>
          <div class="modal-body mx-2 my-2">
            <!-- <div class="row">
              <div class="designation-modal">Designation</div>
              <div class="ux-desinger">HR Executive</div>
            </div> -->
            <table>
              <tr>
                <td class="width-left-data">Designation :</td>
                <td class="width-right-data">
                  {{ modalRecord[0]["designation"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Department :</td>
                <td class="width-right-data">
                  {{ modalRecord[0]["department"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Job Location :</td>
                <td class="width-right-data">
                  {{ modalRecord[0]["jobLocation"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Email :</td>
                <td class="width-right-data">
                  {{ modalRecord[0][0]["email_id"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Reporting Manager :</td>
                <td class="width-right-data">
                  {{ modalRecord[0]["reportingManager"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">DOJ :</td>
                <td class="width-right-data">
                  {{ formatDate(modalRecord[0]["date_of_joining"]) }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Emergency Contact name :</td>
                <td class="width-right-data">
                  {{ modalRecord[0][0]["emergency_contact_name"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Emergency Contact :</td>
                <td class="width-right-data">
                  {{ modalRecord[0][0]["emergency_contact_number"] }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "indirectReportee",
  props: {
    // directReporteesList: {
    //   type: Array,
    // },
    // tableData: {
    //   type: Array,
    // }
  },
  data() {
    return {
      employeeTableColumns: [
        {
          label: "",
          key: "photo",
        },
        {
          label: "Code",
          key: "code",
        },
        {
          label: "Name",
          key: "name",
        },
        {
          label: "Email",
          key: "emailID",
        },
        {
          label: "Designation",
          key: "designation",
        },
        {
          label: "Location",
          key: "location",
        },
      ],
      seen: true,
      showModal: false,
      modalRecord: null,
      actionTypeVar: "",
      showActionMenu: false,
      employeeData: [],
      showFilter: false,
      directReporteesList: [],
      indirectReporteesList: [],
      tempList:[],
      role: "",
      employee_id: "",
    }
  },
  created() {
    //this.lopData = [...this.directReporteesList];
  },
  activated() {
    let d = new Date();
    this.month = this.monthsList[d.getMonth()];
    //this.lopData = [...this.directReporteesList];
    // this.fetchAllEmployeesLOPRLOP();
    this.getOrgLeIdList();
  },
  mounted() {
    this.fetchMyTeamReportee();
    let d = new Date();
    this.month = this.monthsList[d.getMonth()];
    //this.lopData = [...this.directReporteesList];
    this.getOrgLeIdList();
    
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ...mapState({
      lopRlopData: state => state.dashboard.payroll.utilities.lopsandrlop
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods: {
    ...mapActions({
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      fetchReportee: "dashboard/myteam/fetchAll",
      getOrgLeList: "onboard/organization/getOrgLeIdList"
    }),

    //Add new methods
    async fetchMyTeamReportee() {
      try {
        const org = this.orgId;
        const le = this.le_id;
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
              ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.employee_id = data.data.user.employee_id;
        //this.reportosValue = data.data.user.permissions.reportos ? true : false;
        
        let res = await this.fetchReportee({
          employee_id: this.employee_id,
        });
        if (res.data.status) {
         this.indirectReporteesList = res.data.payload[0].indirectReportees.data;
          this.indirectReporteeCount = res.data.payload[0].indirectReportees.count;
          this.tempList = res.data.payload[0].indirectReportees.data;          
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to search in local by name */
    filterData(val) {
      try {
        let tempArray = [];
        this.tempList.forEach(element => {
          if (element['name']) {         
            if (element['name'].toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          this.indirectReporteesList = tempArray;
        } else {
          this.indirectReporteesList = this.tempList;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    //End here

    
    formatDate(date) {
      var myDate = new Date(date);
      var month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ][myDate.getMonth()];
      var str = myDate.getDate() + " " + month + " " + myDate.getFullYear();
      return str;
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.employee_id = data.data.user.employee_id;
      //this.reportosValue = data.data.user.permissions.reportos ? true : false;
    },
    
  },
};
</script>


<style lang="scss" scoped>
@import "@/scss/components/margins.scss";

// Filter css
.filters[data-v-564388ad] {
  width: auto;
  height: auto;
  display: grid;
} 
// End here 

.nav {
  color: #555555;
  font-size: 11px;
  margin-left: 10px;
}
.grid-title {
  display: grid;
  grid-template-columns: 4fr 4fr 4fr 4fr 4fr;
  grid-template-rows: 2fr;
  grid-gap: 4px;
  padding: 10px;
  color: #646464;
  font-size: 16px;

  b {
    font-size: 24px;
  }
}
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
}

.modal-content-history {
  background-color: white;
  margin: 60px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 375px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 0px;

  .datatableClass {
    margin-left: 10%;
    margin-top: 5%;
    overflow-y: scroll;
  }
}
.top-bar {
  background-color: #34c0be;
  display: flex;
  width: 108%;
  height: 85px;
  margin-top: -30px;
}
.heading_new {
  font-family: Montserrat;
  font-size: 22px;
  font-weight: bold;
  padding: 10px;
  color: #ffffff;
}
.imagearea {
  display: flex;

  img {
    padding: 10px;
    margin-left: 5%;
    width: 90px;
    height: 90px;
  }
}
.emp-header {
  padding: 20px 0px 0px 10px;
  display: flex;
  .text {
    font-size: 16px;
    color: #646464;
    margin-right: 10px;
  }

  .line {
    border-bottom: 1px solid #34c0be;
    flex-grow: 1;
  }
}

.filters-section {
  display: flex;
  align-items: flex-end;
  margin-top: 30px;
  margin-left: 10px;
  // overflow: scroll;
  *:nth-child(1) {
    margin-right: 10px;
  }
}

.selectdiv {
  select {
    max-width: 200px;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9c9c9c;
    border: 1px solid #dadada;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    // background: url("@/assets/stroke-1.png");
    background-size: 12px;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;

    option {
      color: #9c9c9c;
      font-size: 12px;
    }
  }
  span {
    color: #b3b3b3;
    font-size: 12px;
  }
}
.filters-button {
  margin-top: 10px;
  width: 95px;
  height: 35px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.search-bar {
  padding: 30px 0px 0px 10px;
  display: flex;
}
.addnewempbtn {
  width: 130%;
  display: flex;
  justify-content: center;
  height: 30px;
  background-color: #5d409f;
  border: #5d409f solid 1px;
  color: #ffffff;
  margin-left: 10px;
  border-radius: 4px;
  align-items: center;
  *:nth-child(n) {
    margin-right: 5px;
  }
}
.export-section {
  margin-left: 6%;
  margin-top: -8px;
  align-items: center;
  display: flex;
}
.export-button {
  width: 70px;
  height: 25px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 3px;
}
.sort-by {
  display: flex;
  margin-left: 7%;

  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}
.side-actions {
  margin-left: 10px;
  margin-top: 10px;
  img {
    cursor: pointer;
    margin-right: 5px;
    margin-left: 5px;
  }
}
.ver-line {
  border-right: solid 1px #30b6bc;
  padding-top: 10px;
}
.employee-cards {
  padding: 30px 0 0 10px;
}
.btnGrp {
  margin-left: 33px;
}
.align-filters {
  display: flex;
  margin: 30px 0 0 10px;
  *:nth-child(1) {
    text-align: center;
  }
  button {
    // margin: 30px 0 0 10px;
    // width: 120px;
    // height: 28px;
    // display: flex;
    border-radius: 100px;
    background-color: #b2f8f7;

    // span {
    //   margin-left: 10px;
    // }
    // img {
    //   margin-left: 56%;
    //   margin-top: 3px;
    // }
  }
}
.filters {
  width: 125px;
  height: 28px;
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  *:nth-child(1) {
    margin-right: 10px;
    padding-left: 5px;
  }
  img {
    margin-top: 3px;
    margin-right: 10px;
    cursor: pointer;
  }
}
.save-tags {
  margin-left: 10px;
  span {
    font-size: 12px;
    cursor: pointer;
  }
}
.btn-popup {
  display: block;
  border-radius: 4px;
  height: 35px;
  width: 120px;
  align-self: center;
  background-color: #5d409f;
  color: #ffffff;
}
.clear-filters {
  font-size: 12px;
  margin-top: 7px;
  margin-left: 19px;
  cursor: pointer;
}
.alignCss {
  padding: 28px;
  margin-bottom: 100px;
}

.card-container {
  width: 100%;
}
.employee {
  width: 32%;
  height: 210px;
  border-radius: 10px;
  border: solid 1px #f2f2f2;
  display: inline-flex;
  background-color: #ffffff;
  margin: 0px 10px 10px 0px;
  //cursor: pointer;
}
.employee-img {
  position: relative;
  width: 51%;
  border-right: 1px solid #f2f2f2;
  // opacity: 0.11;
  padding: 18px; // 10px
  height: 100%;
}
.imgDetails {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .link-actions {
    margin-left: 10px;
    display: flex;
    justify-content: space-between;
  }
}
.action-container {
  right: 15px;
  position: absolute;
  display: flex;
  // flex-direction: column;
  img {
    cursor: pointer;
  }
}
.action {
  width: 4px;
  height: 4px;
  margin: 4px;
  color: #000000;
}
.employee-details {
  width: 60%;
  padding: 18px; //12px
  position: relative;
}
.checkbox {
  position: absolute;
  height: 18px;
  width: 18px;
  border-radius: 4px;
  border: 1px solid #f2f2f2;
  background-color: #ffffff;
}
.empId {
  color: #878787;
  font-size: 12px;
  text-align: center;
}
.empName {
  font-family: Montserrat;
  font-size: 14px;
  color: #979797;
  // margin-left: 13px;
  color: #646464;
  font-weight: 500;
  text-transform: capitalize;
}
.empDetails {
  font-family: Montserrat;
  font-size: 12px;
  color: #979797;
  text-align: center;
  // margin-left: 30px;
  text-transform: capitalize;
}
.details {
  font-family: Montserrat;
  font-size: 12px;
  color: #878787;
  img {
    width: 10px;
    height: 10px;
    margin-right: 5px;
  }
}
.link-actions {
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  img {
    width: 13px;
    height: 13px;
  }
}
button {
  margin-top: 10px;
  width: 75px;
  height: 20px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.joining-time {
  color: #5d409f;
  font-size: 12px;
  margin-top: 10px;
}
.offer-status {
  color: #5d409f;
  font-size: 12px;
  cursor: pointer;
}

.action-container-icon {
  margin-left: 98%;
}
.action-menu {
  width: 128px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.23);
  background-color: #ffffff;
  margin-right: 10px;
  border-right: 20px solid #ffffff;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;

  .edit {
    cursor: pointer;
    // margin-left: 5px;
    font-size: 12px;
    padding: 5px 0px 5px 5px;
    color: #616363;
    width: 120px;
    // text-align: center;

    &:hover {
      border: 1px solid #c0edeb;
      // width: 120px;
      // height: 20px;
      // color:red;
      background-color: #c0edeb;
    }
  }
}
// .selected {
//      &.hover {
//         border: 1px solid #c0edeb;
//         width: 120px;
//         height: 40px;
//         background-color: #c0edeb;
//      }
// }
.action-menu:after {
  filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
  position: absolute;
  width: 0;
  top: 0px;
  right: 5%;
  height: 0;
  content: "";
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 10px solid #ffffff;
  filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
}

.progress-bar {
  margin-top: 20px;
  margin-bottom: 5px;
  width: 108px;
  height: 8px;
  border-radius: 4px;
  border: solid 1px #34c0be;
  background-color: #ffffff;
  position: relative;
}
.progress {
  position: absolute;
  background-color: #b2f8f7;
  width: 50%;
  border-radius: 4px;
  height: 6px;
}
.show-progress {
  padding: 7px;
  color: #5d409f;
  font-size: 12px;
}

.search-container {
  width: 300px;
  position: relative;
  max-width: 321px;
  span {
    position: absolute;
    padding: 10px;
  }
}
.search-bar {
  width: 100%;
  border: 1px solid #d6d4d4;
  border-radius: 3px;
  height: 35px;
  padding: 5px;
  outline: none;
  position: relative;
}
.search-icon {
  position: absolute;
  right: 10px;
  top: 6px;
  width: 18px;
  height: 18px;
  left: inherit;
}

img.search-icon-filter {
  position: relative;
  right: 5px;
  top: 8px;
  width: 30px;
  height: 30px;
  // margin: 38px 6px 29px 32px;
  padding: 7px 4px 6px;
}
span.filter-text {
  font-weight: 600;
  color: #34c0be;
  font-size: 14px;
}

.filter-width {
  width: 390px;
}

.show-filter-block {
  position: absolute;
  transform: translate(-5%, -12%);
  cursor: pointer;
}

.download-block {
  position: absolute;
  width: 302px;
  transform: translate(-65%, -24%);
}

.grid-list-block {
  transform: translate(0%, -12%);
}

a.anchor-underline-none {
  text-decoration: none;
}


.line {
  width: 1px;
  height: 18px;
  margin: 0px 13px 0px 1px; //41px 13px 32px 15px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.user-img {
  // width: 45%;
  height: 45px;
  border-radius: 50%;
  width: 45px;
}

.modal-user-img {
  width: 25%;
  margin-bottom: 10px;
}

.modal-emp-name {
  width: 112px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
}

.modal-emp-code {
  width: 146px;
  height: 15px;
  // margin: 4px 121px 0 136px;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
}

.modal-emp-header {
  background-color: #ebebeb;
  padding: 25px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.modal-border-radius {
  border-radius: 8px;
}

img.close-img {
  float: right;
  cursor: pointer;
}

.datatable-outer-container {
  table.datatable {
    .record-row {
      cursor: pointer !important;
    }
  }
}

.width-left-data {
  width: 400px;
  font-family: Montserrat;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: #444444;
  font-size: 0.9rem;
}

.width-right-data {
  width: 400px;
  font-family: Montserrat;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #444444;
  font-size: 0.9rem;
}

img.userImg {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
</style>

